import { useContext } from 'react'

import { ToastContext } from '@reveni-io/reveni-ui'

import RichTextEditor from '@/common/components/RichTextEditor/RichTextEditor'
import { getEmailVariables } from '@/common/helpers/helpers'
import useAddImage from '@/common/hooks/useAddImage/useAddImage'
import useAddLink from '@/common/hooks/useAddLink/useAddLink'
import useAddVariable from '@/common/hooks/useAddVariable/useAddVariable'

import AddLinkPopover from './AddLinkPopover/AddLinkPopover'
import { emailToolbarConfig } from './constants'
import { getLinkableVariables, getSectionsWithLinkableVariables } from './helpers'

const Content = ({
  content,
  onChangeContent,
  languageSelected,
  availableVariables,
  availableSections,
  disabled,
  merchantId,
}) => {
  const { editorRef, onAddVariable } = useAddVariable({ onChange: onChangeContent })
  const { toolbarRef, showLinkPopup, openAddLinkPopup, onCloseLinkPopup, onAddLink } = useAddLink({
    editorRef,
    onChange: onChangeContent,
  })
  const { setToastInfo } = useContext(ToastContext)
  const { onImageUpload, triggerImageUpload } = useAddImage({ merchantId, setToastInfo, editorRef })

  return (
    <>
      <RichTextEditor
        value={content}
        onChange={onChangeContent}
        config={emailToolbarConfig}
        minHeight="330px"
        toolbarRef={toolbarRef}
        editorRef={editorRef}
        languageKey={languageSelected}
        variables={getEmailVariables(availableVariables)}
        disabled={disabled}
        onAddLink={openAddLinkPopup}
        onAddImage={triggerImageUpload}
        onAddVariable={onAddVariable}
        availableVariables={availableVariables}
        availableSections={availableSections}
        onImageUpload={onImageUpload}
      />
      <AddLinkPopover
        toolbarRef={toolbarRef}
        availableVariables={getLinkableVariables(availableVariables)}
        availableSections={getSectionsWithLinkableVariables(availableVariables, availableSections)}
        show={showLinkPopup}
        onClose={onCloseLinkPopup}
        onAddLink={onAddLink}
      />
    </>
  )
}

export default Content
